import { createFileRoute } from '@tanstack/react-router';
import { DripGoalSubTab } from '@/components/admin/DripGoalSubTab';

function Page() {
  return <DripGoalSubTab goal='retention' />;
}

export const Route = createFileRoute('/admin/drip-campaigns/retention')({
  component: Page,
});
